import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea, Chip } from '@mui/material';
import './ArticleCard.css';
import Anchor from '../../buttons/Anchor';


export default function ArticleCard({data, style}) {
  // /article/view/6
  return (
    <div className='article-card-container' style={style}>
        <div className='article-card'>
          <Anchor to={`/article/view/${data.id}`} sx={{flexGrow: '1'}}>
          <CardActionArea sx={{height: '100%',  display: 'flex',flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'baseline' }}>
            <div className='article-card-image'>
              <CardMedia
                component="img"
                width="100%"
                height="100%"
                image={data.image.fileContent}
                alt={data.image.fileContent}
                sx={{objectFit: "cover"}}
              />
            </div>            
            <CardContent className='article-card-content' sx={{paddingBottom: "0px !important", maxHeight: "16vh"}}>
              <Typography className='article-card-typo' gutterBottom variant="h5" component="div" title={data.title}>
                {data.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {data.description}
              </Typography>
            </CardContent>
            <div className='tag-container' style={{position: "absolute", bottom: "0"}}>
              {data.tags !== "" ? data.tags.map((tag, index) => (<Chip sx={{height: '17px'}} key={index} label={`#${tag}`} size="small" />)) : null}
            </div>            
          </CardActionArea>
          </Anchor>
        </div>
    </div>
  );
}